{
  "general.loading": "Loading...",
  "general.success": "Success",
  "site_type_select.label": "Select Development Site",
  "site_type_select.create_new_dev_site": "Create a new Development Site",
  "site_type_select.create_new_dev_site.disabled": "You have reached the maximum number of {limit} Development Sites",
  "site_type_select.pick_existing_site": "Pick an existing site",
  "site_type_select.no_sites": "No sites found",
  "create_dev_site.loading": "Creating your new Development Site...",
  "create_dev_site.success": "Development Site <0>{name}</0> created successfully! 🚀",
  "site_list_select.label": "Select Site",
  "install_app_on_site.warning": "Your new application needs to be installed on the selected Development Site",
  "install_app_on_site.warning.instructions": "Press <0/> to install the application in your browser",
  "install_app_on_site.finished_successfully": "App installed on Development Site."
}
